import { FC } from 'react';
import { InlineNotification } from '@carbon/react';
import { formatTcWorkspaceDate } from 'utils/dates';
import type { RoyaltyCheckSourceDocument } from './types';

interface SourceDocumentBannerProps {
  sourceDocument: RoyaltyCheckSourceDocument | null;
}

// Detail-page provenance banner for Auto-Connected (Provisioned) royalty checks,
// mirroring the AFE catalog's SourceDocumentBanner.
const SourceDocumentBanner: FC<SourceDocumentBannerProps> = ({
  sourceDocument,
}) => {
  if (!sourceDocument) return null;

  const docLabel =
    sourceDocument.documentTitle ?? `Document #${sourceDocument.id}`;
  const populatedAt = formatTcWorkspaceDate(sourceDocument.autoConnectedAt);

  return (
    <InlineNotification
      kind="info"
      lowContrast
      hideCloseButton
      title="Auto-Connected"
      subtitle={`Auto-populated from ${docLabel} on ${populatedAt}.`}
    />
  );
};

export { SourceDocumentBanner };
